/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

interface LogoProps extends SvgProps {
  isDark: boolean;
}

const Logo: React.FC<LogoProps> = ({ isDark, ...props }) => {

  return (
    <Svg viewBox="0 0 150 50" {...props}>
      {isDark ? (
        <image width={50} href="/images/logoWithText-dark.png" />
      ) : (
        <image width={50} href="/images/logoWithText.png" />
      )}
      

    </Svg>
  );
};

export default React.memo(Logo, (prev, next) => prev.isDark === next.isDark);
